import SplitDomainListsDashboard from "./SplitDomainListsDashboard";

export default SplitDomainListsDashboard;
